import { useQuery } from '@tanstack/react-query';
import { getLegalEntities } from '../queries/legalEntities.queries';

export const useLegalEntities = () =>
    useQuery({
        queryKey: ['legalEntities', 'list'],
        queryFn: () => getLegalEntities(),
    });
